export default class TwitterSlider {
  constructor() {
    if (!this.setVars()) return;

    this.setEvents();
    this.setupSlideHeight(0);
  }

  setVars() {
    this.sliderContainer = document.querySelector('.twitterBox__content');
    if (!this.sliderContainer) return false;
    this.slideElements = this.sliderContainer.querySelectorAll('p');
    if (!this.slideElements.length) return false;

    this.currentSlide = 0;
    this.previousSlideValue = null;
    this.slideShowInterval = 50000;
    this.timeOut = setInterval(this.autoSlides.bind(this), this.slideShowInterval);
    this.sliderButtons = document.querySelectorAll('.twitterBox__control');

    return true;
  }

  setEvents() {
    this.slideElements[0].classList.add('visible');

    Object.keys(this.sliderButtons).forEach(key => {
      this.sliderButtons[key].addEventListener('click', e => {
        this.pickSlide(+e.target.dataset.id);
      });
    });
  }

  changeSlide() {
    clearTimeout(this.timeOut);
    this.timeOut = setInterval(this.autoSlides.bind(this), this.slideShowInterval);

    this.slideElements[this.previousSlideValue].classList.remove('visible');
    this.sliderButtons[this.previousSlideValue].classList.remove('active');

    this.sliderButtons[this.currentSlide].classList.add('active');
    this.slideElements[this.currentSlide].classList.add('visible');

    this.setupSlideHeight(this.currentSlide);
  }

  setupSlideHeight(slideNumber) {
    const contentHeight = this.slideElements[slideNumber].offsetHeight;
    this.slideElements[slideNumber].parentElement.style.minHeight = contentHeight + 20 + 'px';
  }

  pickSlide(number) {
    this.previousSlideValue = this.currentSlide;
    this.currentSlide = number;
    this.changeSlide();
  }

  autoSlides() {
    this.pickSlide((this.currentSlide + 1 > this.slideElements.length - 1)
      ? 0
      : this.currentSlide + 1);
  }
}
